import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Aurora from './components/Aurora';

const Landing = lazy(() => import('./pages/Landing'));
const Assessment = lazy(() => import('./pages/Assessment'));
const Results = lazy(() => import('./pages/Results'));
const Book = lazy(() => import('./pages/Book'));
const Privacy = lazy(() => import('./pages/Privacy'));
const NotFound = lazy(() => import('./pages/NotFound'));

function Loading() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center text-text-secondary">
      <div className="animate-pulse">Loading…</div>
    </div>
  );
}

export default function App() {
  return (
    <>
      <Aurora />
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route path="/" element={<Navigate to="/gym-money-audit" replace />} />
          <Route path="/gym-money-audit" element={<Landing />} />
          <Route path="/gym-money-audit/assessment" element={<Assessment />} />
          <Route path="/gym-money-audit/results/:resultId" element={<Results />} />
          <Route path="/gym-money-audit/book" element={<Book />} />
          <Route path="/gym-money-audit/privacy" element={<Privacy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </>
  );
}
